import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';

import {TooltipPosition} from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { Role, User } from 'src/app/_models';
import { AuthenticationService } from 'src/app/_services';

import { UserService } from '../../_services';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  showFiller = false;
  linkActive: string;
  linkSelected: any;
  e:string;
  lng: any;
  show = false ;
  currentUser: User;
  loading = false;

  userFromApi: User;
  constructor(private router: Router,
    private authenticationService: AuthenticationService , private userService: UserService,private http: HttpClient,   private titleService:Title) { 
      this.authenticationService.currentUser.subscribe(x => this.currentUser = x);        
       this.currentUser = this.authenticationService.currentUserValue;
    }

  ngOnInit(): void {
    
    this.userFromApi =  this.authenticationService.currentUserValue
    console.log( this.authenticationService.currentUserValue)
    this.userService.getById().pipe(first()).subscribe(user => {
      this.loading = false;
    //  this.userFromApi = user;

      console.log(user.status)
      if (user.status != null ) {
       this.logout() 
       window.location.href= '/login'
      }

  });

    this.lng =  localStorage.getItem('langue')
   
    this.linkSelected = localStorage.getItem("link")
    console.log(this.linkSelected)
    //this.RedirectGo(this.e);
    this.loading = true;

  }

  RedirectGo(e){
  //  this.router.navigate([e]);
    this.linkActive =e

    localStorage.setItem('link', this.linkActive);


  }
  get isAdmin() {
    return this.currentUser && this.currentUser.role === Role.Admin;
}

  logout() {
    this.http.post('http://192.168.1.98:8000/api/logout',{}).subscribe(data => {
      console.log(data)
   
  
    })
    this.authenticationService.logout();
    document.getElementById('favicon').setAttribute('href', 'https://app.stgdrive.com/assets/1.16:85/ctx/images/custom/stg/favicon.ico');
    this.titleService.setTitle("STG DRIVE");
  window.location.href= '/login'

 
   
}
 showDiv(){
  this.show = !this.show;
}
}
